"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _default = function _default(rgba) {
  if (!rgba) return {};
  var rgbaArray = rgba.replace(/rgba?\(|\s+|\)/g, "").split(",");
  var obj = {
    r: parseInt(rgbaArray[0], 10),
    g: parseInt(rgbaArray[1], 10),
    b: parseInt(rgbaArray[2], 10),
    a: parseFloat(rgbaArray[3])
  };
  return obj;
};

exports["default"] = _default;
module.exports = exports.default;